<template>
  <div class="d-flex justify-content-between">
    <div class="d-flex">
      <nav id="countShow" class="bs-pagination position-relative d-sm-flex" v-if="state">
        <div class="page-item active">
          <button class="page-link d-sm-none my-2">
            {{ state.tableRows }}
          </button>
        </div>
        <ul class="pagination my-2 bg-light d-none d-sm-flex" v-if="state && state.tableRows">
          <li class="page-item" v-for="c in counts" :key="'c' + c" :class="{'active': c === state.tableRows}">
            <button class="page-link" @click="$emit('pushPage', 1, c)">{{ c }}</button>
          </li>
        </ul>
      </nav>
      <nav class="bs-pagination position-relative d-sm-flex">
        <ul class="pagination my-2 px-1 border-left" v-if="filters">
          <li v-if="filters.after" class="page-item dropup" :class="state.filters.after ? 'active' : ''">
            <button class="page-link dropdown-toggle">
              <fa-icon :icon="['fal', 'calendar-check']"></fa-icon>
            </button>
            <div class="dropdown-menu">
              <button
                  v-for="filter in filterTypes.after.filters"
                  :key="'fa-' + filter"
                  @click="pushFilter({ after: filter })"
                  class="dropdown-item"
              >
                {{ $t('labels.filters.' + filter) }}
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" @click="pushFilter({ after: null })">{{ $t('labels.clear') }}</button>
            </div>
          </li>
          <li v-if="filters.last" class="page-item dropup" :class="state.filters.last ? 'active' : ''">
            <button class="page-link dropdown-toggle">
              <fa-icon :icon="['fal', 'calendar-check']"></fa-icon>
            </button>
            <div class="dropdown-menu">
              <button
                  v-for="filter in filterTypes.last.filters"
                  :key="'fa-' + filter"
                  @click="pushFilter({ last: filter })"
                  class="dropdown-item"
              >
                {{ $t('labels.filters.' + filter) }}
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" @click="pushFilter({ last: null })">{{ $t('labels.clear') }}</button>
            </div>
          </li>
          <li v-if="filters.during" class="page-item dropup" :class="state.filters.during ? 'active' : ''">
            <button class="page-link dropdown-toggle">
              <fa-icon :icon="['fal', 'calendar-check']"></fa-icon>
            </button>
            <div class="dropdown-menu">
              <button
                  v-for="filter in filterTypes.during.filters"
                  :key="'fa-' + filter"
                  @click="pushFilter({ during: filter })"
                  class="dropdown-item"
              >
                {{ $t('labels.filters.' + filter) }}
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" @click="pushFilter({ during: null })">{{ $t('labels.clear') }}</button>
            </div>
          </li>
          <li v-if="filters.budget" class="page-item dropup" :class="state.filters.budget ? 'active' : ''">
            <button class="page-link dropdown-toggle">
              <fa-icon :icon="['fal', 'coins']"></fa-icon>
            </button>
            <div class="dropdown-menu">
              <button
                  v-for="filter in filterTypes.budget.filters"
                  :key="'fc-' + filter.id"
                  @click="pushFilter({ budget: filter.id })"
                  class="dropdown-item"
              >
                {{ filter.label }}
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" @click="pushFilter({ budget: null })">{{ $t('labels.clear') }}</button>
            </div>
          </li>
          <li v-if="filters.fund" class="page-item dropup" :class="state.filters.fund ? 'active' : ''">
            <button class="page-link dropdown-toggle">
              <fa-icon :icon="['fal', 'piggy-bank']"></fa-icon>
            </button>
            <div class="dropdown-menu">
              <button
                  v-for="filter in filterTypes.fund.filters"
                  :key="'fc-' + filter.id"
                  @click="pushFilter({ fund: filter.id })"
                  class="dropdown-item"
              >
                {{ filter.label }}
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" @click="pushFilter({ fund: null })">{{ $t('labels.clear') }}</button>
            </div>
          </li>
          <li v-if="filters.tag" class="page-item dropup" :class="state.filters.tag ? 'active' : ''">
            <button class="page-link dropdown-toggle">
              <fa-icon :icon="['fal', 'tags']"></fa-icon>
            </button>
            <div class="dropdown-menu">
              <button
                  v-for="filter in filterTypes.tag.filters"
                  :key="'rt-' + filter.id"
                  @click="pushFilter({ tag: filter.id })"
                  class="dropdown-item"
              >
                {{ filter.label }}
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" @click="pushFilter({ tag: null })">{{ $t('labels.clear') }}</button>
            </div>
          </li>
        </ul>
      </nav>
    </div>
    <nav class="bs-pagination">
      <ul class="pagination my-2" v-if="lastPage > 1">
        <li class="page-item" v-if="currentPage > 1">
          <button class="page-link" aria-label="Previous" @click="$emit('pushPage', 1)">
            <fa-icon :icon="['fal', 'chevron-left']"></fa-icon>
          </button>
        </li>
        <li class="page-item" v-for="page in pages" :key="'p' + page" :class="{'active': page === currentPage}">
          <button class="page-link" @click="$emit('pushPage', page)">{{ page }}</button>
        </li>
        <li class="page-item" v-if="currentPage < lastPage">
          <button class="page-link" aria-label="Next" @click="$emit('pushPage', lastPage)">
            <span aria-hidden="true"><fa-icon :icon="['fal', 'chevron-right']"></fa-icon></span>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    data: Object,
    state: Object,
    filters: Object,
    counts: {
      type: Array,
      default: () => { return [10, 20, 50, 100] }
    }
  },
  data () {
    return {
      offset: 1,
      filterTypes: {
        after: {
          show: false,
          filters: [
            'from_today',
            'from_week',
            'from_month',
            'from_quarter',
            'from_financial_year',
            'from_year'
          ]
        },
        last: {
          show: false,
          filters: [
            'last_30',
            'last_60',
            'last_90',
            'last_120',
            'last_6',
            'last_9',
            'last_year'
          ]
        },
        during: {
          show: false,
          filters: [
            'today',
            'this_week',
            'this_month',
            'last_month',
            'this_quarter',
            'last_quarter',
            'this_year',
            'last_year'
          ]
        },
        budget: {
          filters: this.$store.state.budgetsStore
        },
        fund: {
          filters: this.$store.state.fundsStore
        },
        tag: {
          filters: this.$store.state.tagsStore
        }
      }
    }
  },
  computed: {
    pages () {
      if (!this.data.meta || !this.data.meta.to) {
        return []
      }
      let from = this.data.meta.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      let to = from + (this.offset * 2)
      if (to >= this.data.meta.last_page) {
        to = this.data.meta.last_page
      }
      const pagesArray = []
      for (let page = from; page <= to; page++) {
        pagesArray.push(page)
      }
      return pagesArray
    },
    currentPage () {
      return this.data.meta ? this.data.meta.current_page : 0
    },
    lastPage () {
      return this.data.meta ? this.data.meta.last_page : 0
    }
  },
  methods: {
    pushFilter (filter) {
      document.activeElement.blur()
      this.filterTypes.after.show = false
      this.$emit('pushPage', 1, null, filter)
    }
  }
}
</script>

<style lang="scss">
.bs-pagination {

  .page-link {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%!important;
    margin: 0 3px;
    padding: 0;
    width: 36px;
    height: 36px;
    font-size: 0.875rem;
  }

  .page-item.active > .page-link {
    box-shadow: 0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08);
  }

  li.page-item:focus-within {

    > .dropdown-menu {
      display: block;
      overflow-x: scroll;
      max-height: 80vh;
    }
  }
}

@media(max-width: 575px) {
  #countShow {

    ul {
      position: absolute;
      bottom: 43px;
      padding: 0.5rem 0;
      border-right: 1px solid var(--border);

      li.page-item {
        margin-bottom: 0.25rem;

        &:first-child {

          .page-link {
            margin-left: auto;
          }
        }
      }
    }

    &:focus-within {

      ul {
        display: block !important;
      }
    }
  }
}
</style>
